<template>
  <div class="enterprise-department">
    <split-pane
      split="vertical"
      :default-percent="20"
      @resize="resize"
      ref="splitPane"
      :min-percent="20"
    >
      <template slot="paneL">
        <div class="left-container">
          <department />
        </div>
      </template>
      <template slot="paneR">
        <div class="right-container">
          <employee-table />
        </div>
      </template>
    </split-pane>
  </div>
</template>

<script>
import SideLayout from "@/layout/side-layout";

import SplitPane from "vue-splitpane";

import Department from "./components/Department";

import EmployeeTable from "./components/EmployeeTable";

export default {
  components: {
    SideLayout,
    SplitPane,
    Department,
    EmployeeTable
  },
  data() {
    return {};
  },
  methods: {
    resize() {
      if (this.$refs.splitPane.percent > 34) this.$refs.splitPane.percent = 34;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
.enterprise-department {
  $margin: 15px;
  margin: $margin;

  background: #f7f7f7;
  height: calc(100vh - #{$topMenuHeight} - #{$margin}* 2);

  .left-container {
    height: 100%;
    background: #fff;
  }

  .right-container {
    height: 100%;
    width: 100%;
    overflow: auto;
    background: #fff;
    padding: 20px;
  }
}

::v-deep .vue-splitter-container {
  .splitter-pane-resizer {
    background: #fff;
    padding: 0 10px;
  }

  .splitter-paneR {
    padding-left: 12px !important;
  }
}
</style>